import { Component, input, model, signal, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { ClientInformation } from 'src/app/models/client-information';
import { ClientContractService } from 'src/app/services/client-contract.service';
import { Subject, takeUntil } from 'rxjs';
import { ClientIntegrationService } from 'src/app/services/client-integration.service';
import { User } from 'src/app/models/user';
import { Integration } from 'src/app/models/integration';
import { ClientContract } from 'src/app/models/client-contract';
import { ToastService } from 'src/app/services/toast.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LTDateTimePickerComponent } from 'src/app/features/lt-input/lt-time-picker/components/lt-datetimepicker/lt-datetimepicker.component';
import { EditClientComponent } from '../edit-client/edit-client.component';
import { ClientContractComponent } from '../client-contracts/client-contracts.component';
import { IntegrationIdentifier } from 'src/app/models/integration-identifier';
import { DestinationEndpoint } from 'src/app/models/destination-endpoint';
import { IdentifierService } from 'src/app/services/identifier.service';

@Component({
  selector: 'app-client-info-view',
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    LTDateTimePickerComponent,
    EditClientComponent,
    ClientContractComponent,
  ],
  templateUrl: './client-info-view.component.html',
  styleUrl: './client-info-view.component.scss',
})
export class ClientInfoViewComponent implements OnDestroy {
  destroyed$: Subject<boolean> = new Subject();
  @ViewChild('clientInfoDialog', { static: true }) clientInfoDialog: TemplateRef<any>;
  @ViewChild('clientContractDialog', { static: true }) clientContractDialog: TemplateRef<any>;
  @ViewChild('clientContractDeleteConfirmationDialog', { static: true }) clientContractDeleteConfirmationDialog: TemplateRef<any>;

  public clientContractTermDate: Date;
  clientContractDialogObject: MatDialogRef<any, any>;
  clientContractToUpdateTermDate: ClientContract[] = null;

  //client = input.required<ClientInformation>();
  client = input<ClientInformation>();
  integration = input<Integration>();
  integrations = input<Integration[]>([]);
  identifiers = input<IntegrationIdentifier[]>([]);
  clientIdentifiers = input<IntegrationIdentifier[]>([]);
  destinationEndpoints = input<DestinationEndpoint[]>([]);

  gettingData = signal<boolean>(false);
  clientContracts = model<ClientContract[]>([]);

  constructor(
    private clientService: ClientIntegrationService,
    private contractService: ClientContractService,
    private identifierService: IdentifierService,
    private toastService: ToastService,
    private dialog: MatDialog,
    private user: User,
  ) {
    this.clientContractTermDate = new Date();
  }

  ngOnDestroy() {
    this.dialog.closeAll();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  openClientInfoDialog() {
    this.dialog.open(this.clientInfoDialog);
  }

  openClientContractDialog() {
    if (this.clientContracts()) {
      this.clientContractDialogObject = this.dialog.open(this.clientContractDialog, { width: '90vw', maxWidth: '1400px', maxHeight: '90vh', minHeight: '75vh', autoFocus: false});
    }
  }

  updateClientContract(event: ClientContract): void {
    this.clientContracts.update(arr => {
      const idx = arr.findIndex(x => x.clientContractId == event.clientContractId);
      if (idx !== -1) {
        const updated = [...arr];
        updated[idx] = event;
        return updated;
      }
      return [...arr, event];
    });
  }

  updateClientContractTermDate(): void {
    if (this.clientContractToUpdateTermDate != null && this.clientContractToUpdateTermDate.length > 0 && this.clientContractTermDate != null) {
      for (const c of this.clientContractToUpdateTermDate) {
        c.contractTermDate = this.clientContractTermDate;
        if (this.clientIdentifiers() != null)
        {
          const matchingId = this.clientIdentifiers().filter(x => x.identifierIdValue == c.identifierIdValue && x.destinationId == c.destinationEndpointId);
          if (matchingId != null && matchingId.length > 0) {
            c.identifierKeyValue = matchingId[0].identifierKeyValue;
            this.contractService.updateClientContract(c)
              .subscribe({
                next: (_value) => {
                  this.toastService.toastCreate('Updated Termination Date for Client Contract ' + c.clientContractId + '.', 'Success');
                  this.updateClientContract(c);
                },
                error: (_error) => {
                  this.toastService.toastCreate('Failed to Update Termination Date for Client Contract ' + c.clientContractId + '.', 'Warning', {
                    autoClose: false,
                  });
                },
            });
          }
        }
      }
    }
  }

  checkContractsForDeletedIntegration(deletedIntegration: Integration): void {
    if (this.clientContracts() != null && this.clientContracts().length > 0) {
      const matchingContracts = this.clientContracts().filter(x =>
        x.integrationMappings.length > 0
        && x.integrationMappings.some(y => y.integrationId == deletedIntegration.integrationId) == true
        && x.integrationMappings.some(y => y.integrationId != deletedIntegration.integrationId) == false,
      );

      if (matchingContracts != null && matchingContracts.length > 0) {
        this.clientContractToUpdateTermDate = matchingContracts;
        this.dialog.open(this.clientContractDeleteConfirmationDialog);
      }
    }
  }


}
